/** The census's six states as the heatmap names them, in the order the legend lists them. */

export type CoverageState =
  | "received"
  | "declared_nil"
  | "missing"
  | "pending"
  | "unknown"
  | "not_expected";

export const COVERAGE_ORDER: readonly CoverageState[] = [
  "received",
  "declared_nil",
  "missing",
  "pending",
  "unknown",
  "not_expected",
];

export const COVERAGE_LABEL: Readonly<Record<CoverageState, string>> = {
  received: "Received",
  declared_nil: "Confirmed none",
  missing: "Missing",
  pending: "Not due yet",
  unknown: "Cannot tell",
  not_expected: "Not expected",
};

export const COVERAGE_MEANING: Readonly<Record<CoverageState, string>> = {
  received: "A bill or reading arrived for this month.",
  declared_nil: "A person said there was nothing to report, with a reason.",
  missing: "Nothing arrived and nothing was declared.",
  pending: "The month has not closed yet.",
  unknown: "Serviced on demand, so nothing arriving may mean nothing was serviced.",
  not_expected: "This source was not expected in this month.",
};
